import produce from 'immer';
import { registerReducer } from '../../../StateSetup/RootReducer';

const { BFF_URL, GBCORE_CLIENT_NAME, GBCORE_CLIENT_VERSION } = window.__ENV__;

// Action names
const ACTION_NAME_PREFIX = 'action/purgeContext';
export const REQUEST_ACTION_NAME = `${ACTION_NAME_PREFIX}/request`;
export const RESPONSE_ACTION_NAME = `${ACTION_NAME_PREFIX}/response`;
export const ERROR_ACTION_NAME = `${ACTION_NAME_PREFIX}/error`;

/**
 * Performs the PurgeApplicationStateAndContext to purge any context from previous no-commit mutations
 *  @param {object} logger
 *  @returns {Promise<object>}
 */
export const PurgeApplicationStateAndContext = () => {
    return async (dispatch, getState, { logger }) => {
        const { jwt, sessionCorrelationId } = getState().Authentication;
        const transactionId = logger.generateGuid();

        // step 1: Request Action
        dispatch({ type: REQUEST_ACTION_NAME });

        logger.info(`${ACTION_NAME_PREFIX}: Purging context.`, {
            correlation: { transactionId },
        });

        const purgeApplicatonStateAndContextMutation = await fetch(`${BFF_URL}/api/v2`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'gb-authorization': jwt,
                'mli-session-correlation-id': sessionCorrelationId,
                'mli-correlation-id': transactionId,
                'mli-channel': 'web',
                'gb-client-name': GBCORE_CLIENT_NAME,
                'gb-client-version': GBCORE_CLIENT_VERSION,
                'is-event-only-session': true,
            },
            body: JSON.stringify({
                operationName: 'RemoveApplicationState',
                variables: {},
                query: `
                        mutation RemoveApplicationState {
                            purgeApplicationStateAndContext
                        }      
                    `,
            }),
        });

        const purgeApplicatonStateAndContextMutationResponse = await purgeApplicatonStateAndContextMutation.json();

        if (purgeApplicatonStateAndContextMutationResponse.errors) {
            const { message, code } = purgeApplicatonStateAndContextMutationResponse.errors[0];
            logger.error(`${ACTION_NAME_PREFIX}: Error purging context. Code: ${code} Reason: ${message}`);
            return dispatch({
                type: ERROR_ACTION_NAME,
                code,
                message,
            });
        }
        return dispatch({
            type: RESPONSE_ACTION_NAME,
            success: true,
        });
    };
};

export const requestReducer = produce((state) => {
    state.MemberData.isPurgeApplicationStateAndContextSaving = true;
});

export const responseReducer = produce((state) => {
    state.MemberData.isPurgeApplicationStateAndContextSaving = false;
});

export const errorReducer = produce((state, action) => {
    state.MemberData.isPurgeApplicationStateAndContextSaving = false;
    state.Errors.purgeApplicationStateAndContext.hasError = true;
    state.Errors.purgeApplicationStateAndContext.code = action.code;
    state.Errors.purgeApplicationStateAndContext.message = action.message;
});

registerReducer(REQUEST_ACTION_NAME, requestReducer);
registerReducer(RESPONSE_ACTION_NAME, responseReducer);
registerReducer(ERROR_ACTION_NAME, errorReducer);
